export default "__VITE_ASSET__DwzYaSh___"